module.exports = __webpack_public_path__ + "static/img/icon9.bed0bbe1.png";